<template>
    <div id="Nav">
      <div class="topCommon">
        <div class="logo">
          <a>
            <img
              :src="imgObj.topLogo"
              @click="goHome"
              alt=""
            />
            <div class="logoFixed">
              <p>中税答疑官网</p>
            </div>
          </a>
          <div class="loginBox">
            <div v-if="user">
              <div class="loginLeft" @click="login(false)">{{ user.username }}</div>
              <div class="loginRight" @click="jumpUser()">个人中心</div>
            </div>
            <div v-else>
              <div class="loginLeft" @click="login(true)">登录</div>
              <div class="loginRight" @click="login(true)">注册</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>

  import topLogo from '@/assets/images/topNav/logo.png'

  // 发送方组件
  import { EventBus } from '@/assets/js/event-bus.js';

  //新加的检索框的引入数据
  import linkJS from '@/config/link'
  const loginLink = linkJS[process.env.NODE_ENV]['loginLink']
  
  //跳转地址
  const linkAll = linkJS[process.env.NODE_ENV]
  
  import { login } from '@/api/api'
  export default {
    data() {
      return {
        imgObj:{
          topLogo
        },
        index: '',
        input: '',
        drawer: false,
        nav: true,
        loading: '',
        consultList: [],
        user: '',
        loginTimer:null,
      }
    },
    created() {
      this.consultList = JSON.parse(localStorage.getItem('consult'))
      this.login(false)
    },
    beforeUpdate() {
      //console.log(this.$route)
      if (this.$route.path == '/nav') {
        this.loading = this.$loading({
          lock: true,
          text: '拼命加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        // debugger
        this.nav = false
        this.loading.close()
      }
      if (this.$route.query.keyWord != false) {
        this.index = this.$route.query.keyWord
      }
    },
    methods: {
      /* 登录系统 */
      // 跳转个人中心
      jumpUser() {
        if (this.$store.state.user.loginBol != true) {
          //window.open(linkAll.loginGr, '_blank')
          this.$router.push('/user')
        } else {
          this.login(true)
        }
      },
      //定时器
      startLoginTimer(tWindow){

        //判断是否有token
        // this.loginTimer = setInterval(() => {
        //   let  tKey = document.cookie.replace(/(?:(?:^|.*;\s*)ZSDY_JSESSION_SID\s*\=\s*([^;]*).*$)|^.*$/, "$1");
        //   if(tKey&&tKey!=''){
        //     //关闭window
        //     tWindow.close();
        //     //清除定时器
        //     clearInterval(this.loginTimer);
        //     this.login(false)
        //   }
        
        // },100)
        
        this.loginTimer = setInterval(() => {
          login().then((res) => {
            //console.log(res)
            if(res.status==200&&res.data.status==0&&res.data.data.id){
              //关闭window
              tWindow.close();
              //清除定时器
              clearInterval(this.loginTimer);
              this.login(false)
            }
          })
        },3000)
      },
      // 登录
      login(v) {
        login().then((res) => {
          if (res.data.status == 401) {
            // 判断是点击登录按钮还是生命周期调用
            if (v) {
              //登录
              let thatUrl = location.href
              let url = encodeURIComponent(thatUrl)
              //window.location.href = loginLink + '' + url

              //先清除定时器
              clearInterval(this.loginTimer);
              //打开页面
              this.myWindow = window.open(loginLink, "登陆", "width=1400,height=800,top=200,left=200");
              //增加定时器 判定
              this.startLoginTimer(this.myWindow)

            } else {
              //console.log('未登录')
              let user = {
                vipInfo: {
                  isVip: 0,
                },
                loginBol: true,
              }
              this.$store.commit('setUser', user)
              sessionStorage.setItem("userInfoData",JSON.stringify({}));
              //console.log(this.$store.state.user)
            }
          } else {
            //console.log('已登录', res)
            this.user = res.data.data
            //console.log(this.$store.state.user)
            this.$store.commit('setUser', this.user)
            //console.log(this.$store.state.user)

            this.userInfo = res.data.data;
            // this.userInfo['isVip'] = res.data.data.vip;
            //存储用户信息
            sessionStorage.setItem("userInfoData",JSON.stringify(this.userInfo));
          }
        })
      },
      //触发回到首页
      goHome(){
        this.$router.push('/')
        //跨组件通讯
        EventBus.$emit('dataForOtherRoute', {path:''});
      }
    },
  }
  </script>
  <style scoped lang="scss">
  * {
    padding: 0;
    margin: 0;
  }
  
  .index {
    width: 100%;
  }
  
  .topCommon {
    width: 100%;
    height: 140px;
    background: #003fa8;
  }
  
  .footCommon {
    width: 100%;
    height: 156px;
    background: #0f59a4;
    font-size: 42px;
    font-weight: normal;
    line-height: 156px;
    letter-spacing: 0em;
    color: #ffffff;
    text-align: center;
  }
  
  .midCommon {
    width: 1200px;
    padding: 0 calc((100% - 1200px) / 2);
    background: #f5f5f5;
    padding-top: 20px;
  }
  
  .logo {
    width: 1200px;
    height: 140px;
    margin: 0 auto;
    position: relative;
    .logoFixed{
      width:300px;
      height:64px;
      line-height: 64px;
      text-align: left;
      font-size:36px;
      position: absolute;
      top:38px;
      left:68px;
      color:#ffffff;
      background: #003fa8;
    }
    .loginBox {
      float: right;
      // width: 100px;
      height: 23px;
      margin-top: 15px;
      margin-right: 58px;
      font-family: Source Han Sans CN;
      font-size: 16px;
      font-weight: normal;
      text-align: right;
      letter-spacing: 0em;
      color: #ffffff;
      .loginLeft {
        padding-right: 8px;
        line-height: 16px;
        border-right: 2px solid #fff;
        display: inline-block;
        cursor: pointer;
      }
      .loginRight {
        padding-left: 8px;
        display: inline-block;
        cursor: pointer;
      }
    }
  }
  
  .logo img {
    /*width: 131px;*/
    /*height: 52px;*/
    width: 300px;
    height: 64px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    -webkit-user-select: none;
    cursor: pointer;

  }
  
  .topBox {
    width: 100%;
    // height: 315px;
    padding: 50px 0;
    margin: 0 auto;
    background: #f3f8fc;
  
    img {
      cursor: pointer;
    }
  }
  
  .search {
    // padding: 0 70px;
    // margin-bottom: 45px;
    width: 1000px;
    margin: 50px auto 0px;
    height: 60px;
  }
  
  .typeBox {
    width: 1200px;
    display: flex;
    margin: 0 auto;
    height: 210px;
    justify-content: space-between;
  }
  
  .typeBox img:hover {
    transform: translateY(-10px);
  }
  
  .hover {
    transform: translateY(-10px);
  }
  
  .searchInput .el-input__inner {
    height: 58px !important;
    border-radius: 0 !important;
    border: 2px solid #0f59a4 !important;
  }
  
  .searchInput {
    width: calc(100% - 450px) !important;
    // height:58px;
    background: #fff;
    margin-right: 10px;
  }
  
  .searchType {
    width: 140px;
    height: 58px;
    line-height: 58px;
    text-align: center;
    background: #0f59a4 !important;
    border: #0f59a4 !important;
    border-radius: 0 !important;
  }
  
  .searchType span {
    font-weight: 700;
    line-height: 18px;
  }
  
  .el-tree .el-input__inner {
    height: 58px !important;
    line-height: 58px !important;
  }
  
  .el-button {
    padding: 0;
  }
  
  // el-tree指示线样式
  .tree_container {
    .el-tree > .el-tree-node:after {
      border-top: none;
    }
  
    .el-tree-node {
      position: relative;
      padding-left: 16px;
    }
  
    //节点有间隙，隐藏掉展开按钮就好了,如果觉得空隙没事可以删掉
    .el-tree-node__expand-icon.is-leaf {
      display: none;
    }
  
    .el-tree-node__children {
      padding-left: 16px;
    }
  
    .el-tree-node :last-child:before {
      height: 38px;
    }
  
    .el-tree > .el-tree-node:before {
      border-left: none;
    }
  
    .el-tree > .el-tree-node:after {
      border-top: none;
    }
  
    .el-tree-node:before {
      content: '';
      left: -4px;
      position: absolute;
      right: auto;
      border-width: 1px;
    }
  
    .el-tree-node:after {
      content: '';
      left: -4px;
      position: absolute;
      right: auto;
      border-width: 1px;
    }
  
    .el-tree-node:before {
      border-left: 1px dashed #e6e6e6;
      bottom: 0px;
      height: 100%;
      top: -22px;
      width: 1px;
    }
  
    .el-tree-node:after {
      border-top: 1px dashed #e6e6e6;
      height: 20px;
      top: 16px;
      width: 24px;
    }
  
    .el-tree-node__content {
      padding-left: 10px !important;
    }
  }
  
  .banner {
    width: 1200px;
    height: 120px;
    margin: 0 auto;
    // position: relative;
  
    // img{
    //   position: absolute;
    // }
    // img:last-child{
    //   position: absolute;
    //   bottom: 30px;
    //   left: 98px;
    // }
  }
  
  .el-table tr {
    background-color: #f5f5f5;
  }
  
  .el-drawer__header > :first-child {
    font-size: 22px;
    color: #333;
  }
  
  .el-table th.el-table__cell > .cell {
    color: #333;
    font-size: 16px;
    font-weight: 700;
  }
  
  .el-table td.el-table__cell {
    border-bottom: none !important;
  }
  
  .el-table th.el-table__cell.is-leaf {
    border-bottom: none !important;
  }
  
  .el-table::before {
    content: '' !important;
    background-color: #fff !important;
  }
  </style>
  